
import {MenuItem} from "./menuItem";
import {getCategoryAnchor} from "../../core/helpers/menuCategoryNavigation";
import {IMenuCategory} from "../../core/interfaces/IMenuCategory";
import {IMenuItem} from "../../core/interfaces/IMenuItem";

export const MenuCategoryList = ({categories, menuItems}: {
    categories: IMenuCategory[];
    menuItems: IMenuItem[];
}) => {

    const renderCategories = (): JSX.Element[] =>
    {
        const finalId = categories[categories.length - 1]?.id;

        return categories.map((cat) =>
        {
            const finalMargin = cat.id === finalId ? 'mb-0' : '';

            return (
                <div key={cat.id ?? cat.name} id={getCategoryAnchor(cat)} className={`flex flex-col ${finalMargin} scroll-margin-top mt-6 first:mt-2`}>
                    <div className="flex items-center gap-2 mx-5 mb-1">
                        <div className="w-1 h-5 rounded-full bg-maroon"></div>
                        <h2 className="text-lg font-bold text-slate-900 tracking-tight">{cat.name}</h2>
                    </div>
                    <div>
                        {menuItems.filter(x => x.categoryId === cat.id).map((item) => (
                            <MenuItem key={item.id} menuItem={item} />
                        ))}
                    </div>
                </div>
            )
        })
    }

    return(
        <div className='flex flex-col w-full pb-4'>
            <div className='flex flex-col w-full'>
                {renderCategories()}
            </div>
        </div>
    )
}
